module.exports = __webpack_public_path__ + "img/spec-ship.d062d1ed.svg";